import type { DateRange } from '$lib/components/pois/types';
import type { DatePickerBasePayload } from '$lib/services/tracking/googleAnalytics/events';
import type {
	DatePickerBaseParams,
	TrackDatePickerParams,
	TrackValidateDatePickersParams,
} from '$lib/services/tracking/googleAnalytics/type';
import { getAccommodationFilterValue } from '$lib/components/pois/filters/utils';
import { track } from '$lib/services/tracking/googleAnalytics';
import { getPoiEventPayload } from '$lib/services/tracking/googleAnalytics/pois';

function buildDatePickerTrackingData({
	context,
	poiCategory,
	searchParams,
}: DatePickerBaseParams): DatePickerBasePayload {
	const accommodationType = getAccommodationFilterValue(searchParams?.filters?.ACCOMMODATION_TYPE);
	const accommodationEquipments = getAccommodationFilterValue(
		searchParams?.filters?.ACCOMMODATION_EQUIPMENT,
	);
	return {
		context,
		poi_category: poiCategory,
		michelin_selection: searchParams?.filters?.MICHELIN_ACCOMMODATION ? 'true' : 'false',
		rate: searchParams?.filters?.ACCOMMODATION_RATE?.toString(),
		poi_distinction: searchParams?.filters?.ACCOMMODATION_STARS?.toString(),
		price_category: searchParams?.filters?.ACCOMMODATION_MAX_PRICE?.toString(),
		types: accommodationType,
		equipments: accommodationEquipments,
	};
}

export function trackOpenDatePickers({
	context,
	poiCategory,
	searchParams,
}: TrackDatePickerParams) {
	track({
		action: 'range_date_field',
		payload: {
			action: 'click',
			...buildDatePickerTrackingData({
				context,
				poiCategory,
				searchParams,
			}),
		},
	});
}

export function trackValidateDatePickers({
	context,
	poiCategory,
	searchParams,
	poi,
}: TrackValidateDatePickersParams) {
	const dateRange = searchParams?.filters?.ACCOMMODATION_AVAILABILITY_DATE_RANGE as DateRange;
	track({
		action: 'validate_date_fields',
		payload: {
			action: 'click',
			checkin_date: dateRange?.startDate,
			checkout_date: dateRange?.endDate,
			...buildDatePickerTrackingData({
				context,
				poiCategory,
				searchParams,
			}),
			...(poi && getPoiEventPayload(poi)),
		},
	});
}
